export const radioReggaeton = {
lunes: [
  {
    startTime: "06:10",
    endTime: "07:00",
    title: "Estrenos Mixtape",
    description: "Lo nuevo nuevo de las listas M®",
    color: "#ff6600",
    src: "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
    cover: "image/radio/0-2/chill-house/cover.jpg",
    voice: [
      {
        text: "Ahora llegan los estrenos de Mixtape.",
      },
      {
        text: "Estás escuchando ${program.title}.",
      },
      {
        text: "Disfruta de aproximadamente ${duration} minutos de música.",
      },
    ],
  },
  {
    startTime: "01:00",
    endTime: "01:30",
    title: "Reggaeton Chileno - Dj Luciano Antileo",
    color: "#16eb60",
    src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
    cover: "../image/radio/reggaeton/djluciano.jpg"
  },
  {
    startTime: "01:30",
    endTime: "02:00",
    title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
    color: "#16eb60",
    src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
    cover: "../image/radio/reggaeton/djluciano-2.jpg"
  },
  {
    startTime: "02:00",
    endTime: "02:26",
    title: "Reggaeton Chileno - Dj Luciano Antileo",
    color: "#16eb60",
    src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
    cover: "../image/radio/reggaeton/djluciano.jpg"
  },
  {
    startTime: "02:26",
    endTime: "02:49",
    title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
    color: "#6d94ff",
    src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
    cover: "../image/radio/reggaeton/djluciano.jpg"
  },
  {
    startTime: "02:49",
    endTime: "04:13",
    title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
    color: "#eb5a16",
    src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
    cover: "../image/radio/reggaeton/fer-palacio.jpg"
  },
  {
    startTime: "04:13",
    endTime: "05:00",
    title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
    color: "#16eb60",
    src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
    cover: "../image/radio/reggaeton/djluciano.jpg"
  },
  
  
  {
    startTime: "08:00",
    endTime: "08:30",
    title: "Reggaeton Chileno - Dj Luciano Antileo",
    color: "#16eb60",
    src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
    cover: "../image/radio/reggaeton/djluciano.jpg"
  },
  {
    startTime: "08:30",
    endTime: "09:01",
    title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
    color: "#16eb60",
    src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
    cover: "../image/radio/reggaeton/djluciano-2.jpg"
  },
  {
    startTime: "09:01",
    endTime: "09:26",
    title: "Reggaeton Chileno - Dj Luciano Antileo",
    color: "#16eb60",
    src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
    cover: "../image/radio/reggaeton/djluciano.jpg"
  },
  {
    startTime: "09:26",
    endTime: "09:49",
    title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
    color: "#6d94ff",
    src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
    cover: "../image/radio/reggaeton/djluciano.jpg"
  },
  {
    startTime: "09:49",
    endTime: "11:13",
    title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
    color: "#eb5a16",
    src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
    cover: "../image/radio/reggaeton/fer-palacio.jpg"
  },
  {
    startTime: "18:40",
    endTime: "19:10",
    title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
    color: "#16eb60",
    src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
    cover: "../image/radio/reggaeton/djluciano.jpg"
  },
  {
    startTime: "19:10",
    endTime: "20:00",
    title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
    color: "#16eb60",
    src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
    cover: "../image/radio/reggaeton/djluciano.jpg"
  },
  {
    startTime: "20:00",
    endTime: "20:30",
    title: "Reggaeton Chileno - Dj Luciano Antileo",
    color: "#16eb60",
    src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
    cover: "../image/radio/reggaeton/djluciano.jpg"
  },
  {
    startTime: "20:30",
    endTime: "21:01",
    title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
    color: "#16eb60",
    src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
    cover: "../image/radio/reggaeton/djluciano-2.jpg"
  },
  {
    startTime: "21:01",
    endTime: "21:26",
    title: "Reggaeton Chileno - Dj Luciano Antileo",
    color: "#16eb60",
    src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
    cover: "../image/radio/reggaeton/djluciano.jpg"
  },
  {
    startTime: "21:26",
    endTime: "21:49",
    title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
    color: "#6d94ff",
    src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
    cover: "../image/radio/reggaeton/djluciano.jpg"
  },
  {
    startTime: "21:49",
    endTime: "23:13",
    title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
    color: "#eb5a16",
    src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
    cover: "../image/radio/reggaeton/fer-palacio.jpg"
  },
  {
    startTime: "23:13",
    endTime: "24:00",
    title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
    color: "#16eb60",
    src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
    cover: "../image/radio/reggaeton/djluciano.jpg"
  },
],

martes: [
    {
      startTime: "00:30",
      endTime: "01:00",
      title: "Estrenos Mixtape",
      description: "Lo nuevo nuevo de las listas M®",
      color: "#ff6600",
      src: "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
      cover: "image/radio/0-2/chill-house/cover.jpg",
      voice: [
        {
          text: "Ahora llegan los estrenos de Mixtape.",
        },
        {
          text: "Estás escuchando ${program.title}.",
        },
        {
          text: "Disfruta de aproximadamente ${duration} minutos de música.",
        },
      ],
    },
    {
      startTime: "01:00",
      endTime: "01:30",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "01:30",
      endTime: "02:00",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano-2.jpg"
    },
    {
      startTime: "02:00",
      endTime: "02:26",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "02:26",
      endTime: "02:49",
      title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
      color: "#6d94ff",
      src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "02:49",
      endTime: "04:13",
      title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
      color: "#eb5a16",
      src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
      cover: "../image/radio/reggaeton/fer-palacio.jpg"
    },
    {
      startTime: "04:13",
      endTime: "05:00",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },


    {
      startTime: "08:00",
      endTime: "08:30",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "08:30",
      endTime: "09:01",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano-2.jpg"
    },
    {
      startTime: "09:01",
      endTime: "09:26",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "09:26",
      endTime: "09:49",
      title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
      color: "#6d94ff",
      src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "16:59",
      endTime: "18:23",
      title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
      color: "#eb5a16",
      src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
      cover: "../image/radio/reggaeton/fer-palacio.jpg"
    },
    {
      startTime: "18:23",
      endTime: "19:00",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "20:00",
      endTime: "20:30",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "20:30",
      endTime: "21:01",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano-2.jpg"
    },
    {
      startTime: "21:01",
      endTime: "21:26",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "21:26",
      endTime: "21:49",
      title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
      color: "#6d94ff",
      src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "21:49",
      endTime: "23:13",
      title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
      color: "#eb5a16",
      src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
      cover: "../image/radio/reggaeton/fer-palacio.jpg"
    },
    {
      startTime: "23:13",
      endTime: "23:59",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
  ],

  miercoles: [
    {
      startTime: "10:53",
      endTime: "11:30",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "18:20",
      endTime: "19:00",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "20:30",
      endTime: "21:01",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano-2.jpg"
    },
    {
      startTime: "21:01",
      endTime: "21:26",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "21:26",
      endTime: "21:49",
      title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
      color: "#6d94ff",
      src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "21:49",
      endTime: "23:13",
      title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
      color: "#eb5a16",
      src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
      cover: "../image/radio/reggaeton/fer-palacio.jpg"
    },
    {
      startTime: "23:13",
      endTime: "24:00",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    }
  ],

  jueves: [
    {
      startTime: "10:00",
      endTime: "10:30",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "10:30",
      endTime: "11:00",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "11:00",
      endTime: "11:30",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano-2.jpg"
    },
    {
      startTime: "11:30",
      endTime: "12:00",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "12:00",
      endTime: "12:30",
      title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
      color: "#6d94ff",
      src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "12:30",
      endTime: "13:50",
      title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
      color: "#eb5a16",
      src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
      cover: "../image/radio/reggaeton/fer-palacio.jpg"
    },
    {
      startTime: "17:00",
      endTime: "17:30",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    }
  ],

  viernes: [
    {
      startTime: "02:30",
      endTime: "03:17",
      title: "Funk, Guaracha, Afro, Dembow - Dj Luciano Antileo",
      description: "Reggaeton 2026",
      color: "#0059ff",
      src: "https://dl.dropbox.com/scl/fi/ge4amkixjj68ade0lvqw2/DJ-Luc14no-Antileo-Set-Live-Pack-24-Perreo-Funk-Guaracha-Afro-Dembow-MIX-LO-NUEVO-6vEPTDfQXuE.mp3?rlkey=cixtsbggo44jlxxkso632s8tr&st=ebx6q6be&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg",

      voice: [
        {
          text: "Ahora en directo, ${program.artist}.",
        },
        {
          text: "Estás escuchando ${program.title}.",
        },
        {
          text: "Disfruta de aproximadamente ${duration} minutos de música.",
        },
      ],
    },
  ],

  sabado: [
    {
      startTime: "19:12",
      endTime: "20:38",
      title: "Lo-Fi",
      description: "Electrónica amable para empezar el día.",
      color: "#ff6600",
      artist: "DJ Luciano Antileo",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "image/set/radioshow/005.jpg",

      voice: [
        {
          text: "Ahora en directo, ${program.artist}.",
          at: "6:14",
        },
        {
          text: "Ahora en directo, ${program.artist}. Ali XD",
          at: "7:00",
        },
        {
          text: "Ahora en directo, ${program.artist}.",
          at: "8:44",
        },
        {
          text: "Estás escuchando su nuevo set.",
          at: "7:54",
        },
        {
          text: "Y seguimos con más música.",
        },
        {
          text: "Disfruta de aproximadamente ${duration} minutos de música.",
          at: "6:50",
        },
      ],
    },

    {
      startTime: "20:30",
      endTime: "21:01",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano-2.jpg",

      voice: [
        {
          text: "Ahora en directo, ${program.artist}.",
        },
        {
          text: "Estás escuchando su nuevo set.",
        },
        {
          text: "Quédate con nosotros, porque todavía queda mucha música por delante.",
        },
      ],
    },
  ],

  domingo: [
    {
      startTime: "00:30",
      endTime: "01:00",
      title: "Estrenos Mixtape",
      description: "Lo nuevo nuevo de las listas M®",
      color: "#ff6600",
      src: "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
      cover: "image/radio/0-2/chill-house/cover.jpg",

      voice: [
        {
          text: "Ahora llegan los estrenos de Mixtape.",
        },
        {
          text: "Estás escuchando ${program.title}.",
        },
        {
          text: "Disfruta de aproximadamente ${duration} minutos de música.",
        },
      ],
    },
    {
      startTime: "01:00",
      endTime: "01:30",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "01:30",
      endTime: "02:00",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano-2.jpg"
    },
    {
      startTime: "02:00",
      endTime: "02:26",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "02:26",
      endTime: "02:49",
      title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
      color: "#6d94ff",
      src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "02:49",
      endTime: "04:13",
      title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
      color: "#eb5a16",
      src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
      cover: "../image/radio/reggaeton/fer-palacio.jpg"
    },
    {
      startTime: "04:13",
      endTime: "04:50",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg",
      voice: [
        {
          text: "Ahora en directo, ${program.artist}.",
          at: "6:14",
        },
        {
          text: "Ahora en directo, ${program.artist}. Ali XD",
          at: "7:00",
        },
        {
          text: "Ahora en directo, ${program.artist}.",
          at: "8:44",
        },
        {
          text: "Estás escuchando su nuevo set.",
          at: "7:54",
        },
        {
          text: "Y seguimos con más música.",
        },
        {
          text: "Disfruta de aproximadamente ${duration} minutos de música.",
          at: "6:50",
        },
      ],
    },
    {
      startTime: "07:40",
      endTime: "07:59",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg",
      voice: [
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "6:14",
          text: "Saludos BirdRadio!! "
        },
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "7:00",
          text: "Saludos BirdRadio!! "
        },
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "8:44",
        },
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "7:54",
        },
        {
          src: "/assets/audio/ad-mixtape.mp3",
          text: "Vamooos Mixtape jeje"
        },
        {
          src: "/test-voice.mp3",
          at: "26:50",
        },
      ],
    },




    
    
    {
      startTime: "08:00",
      endTime: "08:30",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg",
      voice: [
        {
          at: "05:10",
          text: "Dj Luciano Antileo"
        },
        {
          src: "/assets/audio/ad-mixtape.mp3",
        }
      ],
    },
    {
      startTime: "08:30",
      endTime: "09:01",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano-2.jpg",
      voice: [
        {
          at: "05:10",
          text: "El capo de Comodoro Rivadavia"
        },
        {
          src: "/assets/audio/ad-mixtape.mp3",
        }
      ],
    },
    {
      startTime: "09:01",
      endTime: "09:26",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg",
      voice: [
        {
          at: "05:10",
          text: "El capo de Comodoro Rivadavia"
        },
        {
          src: "/assets/audio/ad-mixtape.mp3",
        }
      ],
    },
    {
      startTime: "09:26",
      endTime: "09:49",
      title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
      color: "#6d94ff",
      src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg",
      voice: [
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "03:14",
          text: "MixtapeRadio"
        },
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "07:00",
          text: "Saludos BirdRadio!! "
        },
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "08:44",
        },
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "14:54",
        },
        {
          src: "/assets/audio/ad-mixtape.mp3",
          text: "Vamooos Urbano"
        },
        {
          src: "/test-voice.mp3",
          at: "26:50",
        },
      ],
    },
    {
      startTime: "09:49",
      endTime: "11:13",
      title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
      color: "#eb5a16",
      src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
      cover: "../image/radio/reggaeton/fer-palacio.jpg",
      voice: [
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "03:14",
          text: "MixtapeRadio"
        },
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "07:00",
          text: "BirdRadio"
        },
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "08:44",
        },
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "14:54",
        },
        {
          src: "/assets/audio/ad-mixtape.mp3",
          text: "Vamooos Urbano"
        },
        {
          src: "/test-voice.mp3",
          at: "26:50",
        },
      ],
    },


    {
      startTime: "13:00",
      endTime: "13:30",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "13:30",
      endTime: "14:00",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano-2.jpg"
    },
    {
      startTime: "14:00",
      endTime: "14:26",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "14:26",
      endTime: "15:00",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },





    
    {
      startTime: "18:43",
      endTime: "19:30",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg",
      voice: [
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "03:14",
          text: "MixtapeRadio"
        },
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "07:00",
          text: "MR!! "
        },
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "08:44",
        },
        {
          src: "/assets/audio/ad-4b.mp3",
          at: "14:54",
        },
        {
          src: "/assets/audio/ad-mixtape.mp3",
          text: "Vamooos Urbano"
        },
        {
          src: "/test-voice.mp3",
          at: "26:50",
        },
      ],
    },






    {
      startTime: "20:00",
      endTime: "20:30",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "20:30",
      endTime: "21:01",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano-2.jpg"
    },
    {
      startTime: "21:01",
      endTime: "21:26",
      title: "Reggaeton Chileno - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "21:26",
      endTime: "21:49",
      title: "PACHANGA & FIESTA - DJ Luc14no Antileo",
      color: "#6d94ff",
      src: "https://dl.dropbox.com/scl/fi/msojsq8hnmo71wnxgos03/MIX-GUARACHA-AFRO-PERREO-PACHANGAX-FIESTA-01-DJ-Luc14no-Antileo-Cossio-Franco-Ulloa-ZRgKXC2k4FQ.mp3?rlkey=zub55p7mtazaaaf71hvczx63a&st=edusivpr&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      startTime: "21:49",
      endTime: "23:13",
      title: "CLASICOS 2026 ｜ CHINOIS IBIZA",
      color: "#eb5a16",
      src: "https://dl.dropbox.com/scl/fi/sn23lmj1t1w88jt05d7b2/MIX-REGGAETON-2026-CLASICOS-CHINOIS-IBIZA-ENGANCHADO-Fer-Palacio-Set-en-Vivo-reggaetonmix-dtua5gYK_GQ.mp3?rlkey=nlotapyzrziw02trfzvoy2s7a&st=fwsn3pte&dl=1",
      cover: "../image/radio/reggaeton/fer-palacio.jpg"
    },
    {
      startTime: "23:13",
      endTime: "23:59",
      title: "PERREO FUNK, AFROTEO, GUARACHA - Dj Luciano Antileo",
      color: "#16eb60",
      src: "https://dl.dropbox.com/scl/fi/5m4zmcn20plb7gkzg2nwa/DJ-Luc14no-Antileo-Set-Live-Pack-27-MIX-PERREO-FUNK-AFROTEO-GUARACHA-LO-NUEVO-2026-1pG4_6D2c6o.mp3?rlkey=9mxrqpqro38bqjsco754v7woa&st=3nw3jrrg&dl=1",
      cover: "../image/radio/reggaeton/djluciano.jpg"
    },
  ],
}